export const no = {
  translation: {
    "Belimo Energy Valve": "Belimo Energy Valve",
    Yes: "Ja",
    No: "Nei",
    "You cannot go back from this position":
      "Du kan ikke gå tilbake fra denne posisjonen",
    Chapters: "Kapitler",
    Start: "Start",
    "Connecting to the Energy Valve":
      "Tilkobling til Energy Valve",
    "Control Source": "Styringskilde",
    "Do you know the design flow rate?":
      "Kjenner du den prosjekterte vannmengden?",
    "Flow Control": "Mengderegulering",

    "Is the building running off fixed or varying flow temperatures?":
      "Bruker bygningen faste eller varierende væsketemperaturer?",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "Varierende væsketemperaturer (skalering av Delta-T-manager)",

    "Fixed flow temperatures (Delta T Manager)":
      "Faste væsketemperaturer (Delta-T-manager)",

    "I am not sure": "Jeg er ikke sikker",
    "Delta T Manager": "Delta T-Manager",
    Scaling: "Skalering",
    "Do you know the power output?":
      "Kjenner du nytteeffekten?",
    "Yes (Power Control)": "Ja (effektregulering)",
    "No (Position Control)": "Nei (posisjonsregulering)",
    "Power Control": "Effektregulering",
    "Position Control": "Posisjonsregulering",
    "Onboard Data Analysis": "Innebygget dataanalyse",

    "Did you get a clear result from the Energy Valve?":
      "Fikk du et tydelig resultat fra Energy Valve?",

    "How do you want to setup your Energy Valve?":
      "Hvordan vil du konfigurere Energy Valve?",

    "Would you like to connect to the cloud?":
      "Vil du koble til skyen?",

    "Cloud Connectivity": "Skytilkobling",

    "Onboard Diagnostics / Download Data":
      "Innebygget diagnostikk / nedlasting av data",

    "Download Data": "Datanedlasting",
    "Send optimization request":
      "Send forespørsel om optimalisering",
    End: "Slutt",

    Subtitles: "Teksting",
    Repeat: "Gjenta",
    Continue: "Fortsette",
  },
};
